import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentReport: null,
    userReports: [],
    loading: false,
    error: null,
};

const testReportSlice = createSlice({
    name: 'testReport',
    initialState,
    reducers: {
        // Get test report
        getTestReport: (state) => {
            state.loading = true;
            state.error = null;
        },
        getTestReportSuccess: (state, action) => {
            state.loading = false;
            state.currentReport = action.payload;
            state.error = null;
        },
        getTestReportFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Create test report
        createTestReport: (state) => {
            state.loading = true;
            state.error = null;
        },
        createTestReportSuccess: (state, action) => {
            state.loading = false;
            state.currentReport = action.payload;
            state.userReports.unshift(action.payload); // Add to beginning of list
            state.error = null;
        },
        createTestReportFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Get user test reports
        getUserTestReports: (state) => {
            state.loading = true;
            state.error = null;
        },
        getUserTestReportsSuccess: (state, action) => {
            state.loading = false;
            state.userReports = action.payload;
            state.error = null;
        },
        getUserTestReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Clear current report
        clearCurrentReport: (state) => {
            state.currentReport = null;
        },

        // Get latest test report
        getLatestTestReport: (state) => {
            state.loading = true;
            state.error = null;
        },
        getLatestTestReportSuccess: (state, action) => {
            state.loading = false;
            state.currentReport = action.payload.data || action.payload;
            state.error = null;
        },
        getLatestTestReportFailure: (state, action) => {
            state.loading = false;
            state.currentReport = null; // No latest report available
            state.error = action.payload;
        },

        // Clear error
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    getTestReport,
    getTestReportSuccess,
    getTestReportFailure,
    createTestReport,
    createTestReportSuccess,
    createTestReportFailure,
    getUserTestReports,
    getUserTestReportsSuccess,
    getUserTestReportsFailure,
    getLatestTestReport,
    getLatestTestReportSuccess,
    getLatestTestReportFailure,
    clearCurrentReport,
    clearError,
} = testReportSlice.actions;

export default testReportSlice.reducer;